import React, { useEffect, useState } from 'react';
import { TimerIcon } from 'lucide-react';
const START_SECONDS = 17 * 60 + 34;
export function Countdown() {
  const [seconds, setSeconds] = useState(START_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setSeconds(prev => prev <= 0 ? START_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const h = Math.floor(seconds / 3600);
  const m = Math.floor(seconds % 3600 / 60);
  const s = seconds % 60;
  const units = [{
    label: 'Hours',
    value: h
  }, {
    label: 'Minutes',
    value: m
  }, {
    label: 'Seconds',
    value: s
  }];
  return <div className="mt-6 rounded-2xl bg-navy-950 px-4 py-5 text-center" role="timer" aria-live="off" data-id="element-19" data-mp="325j6il7518y1">
      <p className="flex items-center justify-center gap-2 text-sm font-extrabold uppercase tracking-wide text-cta" data-id="element-20" data-mp="374vsz4u3ke03">
        <TimerIcon className="h-4 w-4" aria-hidden="true" data-id="element-21" data-mp="10aihtopj1t0g" />
        The promotional price ends in
      </p>
      <div className="mt-3 flex items-start justify-center gap-2 sm:gap-3" data-id="element-22" data-mp="y16kj8y5q3q6">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-23" data-mp="t2d9roa98qtp" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-24" data-mp="t1k8v3xz8vjh">
              <span className="min-w-[68px] rounded-xl bg-white px-2 py-2 text-[34px] font-black tabular-nums leading-none text-navy-950 sm:min-w-[80px] sm:text-[42px]" data-id="element-25" data-mp="17rhpmytkuiyn">
                {String(u.value).padStart(2, '0')}
              </span>
              <span className="mt-1.5 text-[11px] font-bold uppercase tracking-wider text-mist" data-id="element-26" data-mp="f2ua7jvient0">{u.label}</span>
            </div>
            {i < units.length - 1 && <span className="pt-2 text-3xl font-black text-white sm:text-4xl" aria-hidden="true" data-id="element-27" data-mp="o38x2no4gaym">
                :
              </span>}
          </React.Fragment>)}
      </div>
    </div>;
}